import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Experience, EsperienzeListConfig, WMAIApiService, SchedaIntense, User } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal } from 'src/app/core/templates';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-esperienzashare-main',
  templateUrl: './esperienzashare-main.component.html'
})

export class EsperienzaShareMainComponent implements OnInit {
  isMapVisible: boolean = false;
  public isUserLoggedIn = false;
  esperienza: Experience;
  schedaintense: SchedaIntense;
  id: number;
  idscheda: number;
  siname: string;
  sidescr: string;
  titolo: string;
  userid: string;
  loading: boolean = true;
  private: boolean = false;
  public: boolean = false;
  fkusers: string;
  username: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private modalService: SuiModalService,
    private translateService: TranslateService
  ) {

    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible =  (mode !== WGisDisplayMode.Invisible);
    });
  }

  ngOnInit() {
    this.isMapVisible = this.wgisservice.getMapVisible();
    if (this.isUserLoggedIn == false)
      this.router.navigateByUrl('/login');

    this.userid = this.auth.getIdUser();

    $('#private .close')
      .on('click', function () {
        $(this)
          .closest('#private')
          .transition('fade')
          ;
      });

    $('#public .close')
      .on('click', function () {
        $(this)
          .closest('#public')
          .transition('fade')
          ;
      });

    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id != null) {
      this.wmaiservice.querySingleEsperienza(this.id, this.translateService.getDefaultLang()).subscribe(data => {
        this.esperienza = data['data'][0];
        if (this.esperienza != null) {
          this.titolo = this.esperienza[0]['title'];
          this.idscheda = this.esperienza[0]['scheda_id'];
          this.username = this.esperienza[0]['userid'];
          this.fkusers = this.esperienza[0]['fk_users'];
          this.wmaiservice.querySingleSchedaIntense(this.esperienza[0]['scheda_id'],this.translateService.getDefaultLang()).subscribe(data => {
            this.schedaintense = data;
            this.siname = this.schedaintense['name'];
            this.sidescr = this.schedaintense['descrizione'];
          });
        }
        this.loading = false;
      });
    }
  }
  
  /**
   * condivisione attraverso il RAS, che si richiede attravero un modal
   */
  shareToRAS() {
    let title: string = this.translateService.instant('modal.esperienzashare.share.title');
    let content:string = this.translateService.instant('modal.esperienzashare.share.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          // this.wmaiservice.shareToRAS(this.id, this.idscheda, this.fkusers).subscribe(data => {
          //   if (data != null)
          //     this.router.navigate(['esperienza/', this.id]);
          // });
          this.public = true;
        })
        .onDeny(() => "");
    }
  }
  /**
   * condivisione privata, attraverso un modal
   */
  shareToPrivate() {
    let title: string = this.translateService.instant('modal.esperienzashare.private.title');
    let content:string = this.translateService.instant('modal.esperienzashare.private.content');
    if (this.esperienza != null) {
      this.modalService
        .open(new ConfirmModal(title, content, ModalSize.Tiny))
        .onApprove(() => {
          // this.wmaiservice.shareToPrivate(this.id, this.idscheda).subscribe(data => {
          //   if (data != null)
          //     this.router.navigate(['esperienza/', this.id]);
          // });
          this.public = true;
        })
        .onDeny(() => "");
    }
  }
}
